import React, { useState } from "react";
import robotImage from "../assets/Robot_404.jpg";
import "../styles/secdevtool.css";

const NotFound = () => {
    const [imageLoaded, setImageLoaded] = useState(false);

    return (
        <main className="notfound-card text-center">
            <h1>404</h1>
            {!imageLoaded && <div className="notfound-placeholder" />}
            <img
                src={robotImage}
                alt="Robot sitting on clouds"
                onLoad={() => setImageLoaded(true)}
                className={`notfound-image ${imageLoaded ? "visible" : "hidden"}`}
            />
            <p className="notfound-text fontLd mb-5">
                Oops! The page you are looking for does not exist.
            </p>
            <p>
                <a
                    href="/"
                    className="notfound-link btn btn-secondary border-0"
                >
                    Back to the homepage
                </a>
            </p>
        </main>
    );
};

export default NotFound;